import { Box, Link, Typography } from '@mui/material'
import TwitterIcon from 'assets/icons/Social/TW.svg'
import { Text } from 'components'
import { CONTACT_SOCIAL_ITEMS } from 'config'
import { color } from 'config/color'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

interface IProps {
  isAuthenticated?: boolean
}

export const FindUs = ({ isAuthenticated = true }: IProps): JSX.Element => {
  const isMobile = useMobileBreakpoints()
  return (
    <Box>
      {isAuthenticated && (
        <>
          <Typography color={color.black} fontWeight='500' fontSize='18px' my={1}>
            Find us at:
          </Typography>
          <Box display='flex' gap={2} flexDirection={isMobile ? 'column' : 'row'}>
            {CONTACT_SOCIAL_ITEMS.slice(0, 3).map((social, index) => {
              return (
                <Link
                  key={index}
                  display='flex'
                  mb={2}
                  alignItems='center'
                  sx={{
                    textDecoration: 'none',
                    fontWeight: '400px',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    window.open(social.link)
                  }}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {social.icon === null
                    ? (
                      <img
                        src={TwitterIcon}
                        alt='Twitter'
                        style={{
                          width: '18px',
                          height: '18px',
                          marginLeft: '3px'
                        }}
                      />
                    )
                    : (
                      <social.icon sx={{ color: color.primary[600] }} />
                    )}
                  <Text
                    fontSize='14px'
                    block='false'
                    color={color.grey[900]}
                    margin='0 0 0 10px'
                  >
                    {social.title}
                  </Text>
                </Link>
              )
            })}
          </Box>
        </>
      )}
    </Box>
  )
}
